import Vue from "vue";
import Unicon from "vue-unicons";
import {
  uniEye,
  uniShareAlt,
  uniTrees,
  uniSmile,
  uniTrophy,
  uniSwatchbook,
  uniNinja,
  uniTrash,
  uniCheckCircle,
  uniCheck,
  uniAngleDown,
  uniEllipsisV,
  uniAngleUp,
  uniTimesCircle,
  uniAlignLeft,
  uniBug,
  uniAlignRight,
  uniAlignJustify,
  uniSmileSquintWinkAlt,
  uniAlignCenter,
  uniAngleRightB,
  uniAngleRight,
  uniText,
  uniAngleLeft,
  uniAngleLeftB,
  uniCornerUpLeftAlt,
  uniTextFields,
  uniPalette,
  uniImage,
  uniArrowUp,
  uniArrowDown,
  uniStopCircle,
  uniPlayCircle,
  uniPizzaSlice,
  uniArrowLeft,
  uniArrowRight,
  uniShoppingCart,
  uniArrowCircleRight,
  uniArrowCircleLeft,
  uniSpin,
  uniSignRight,
  uniHeart,
  uniBookAlt,
  uniToggleOff,
  uniToggleOn,
  uniShare,
  uniRotate360
} from "vue-unicons/src/icons";

Unicon.add([
  uniEye,
  uniShare, 
  uniShareAlt,
  uniSmile,
  uniArrowCircleRight,
  uniBookAlt,
  uniCheck,
  uniArrowCircleLeft,
  uniTrees,
  uniToggleOff,
  uniToggleOn,
  uniSignRight,
  uniHeart,
  uniNinja,
  uniRotate360,
  uniStopCircle,
  uniPlayCircle,
  uniTrophy,
  uniEllipsisV,
  uniSwatchbook,
  uniTrash,
  uniCheckCircle,
  uniPizzaSlice,
  uniAngleDown,
  uniAngleUp,
  uniTimesCircle,
  uniAlignLeft,
  uniBug,
  uniAlignRight,
  uniAlignJustify,
  uniText,
  uniAlignCenter,
  uniSmileSquintWinkAlt,
  uniAngleRightB,
  uniAngleRight,
  uniCornerUpLeftAlt,
  uniAngleLeft,
  uniAngleLeftB,
  uniTextFields,
  uniPalette,
  uniImage,
  uniArrowUp,
  uniArrowDown,
  uniArrowLeft,
  uniArrowRight,
  uniShoppingCart,
  uniSpin,
]);
Vue.use(Unicon);
